import { appSettings } from '../context'

class AnchorLinks {
    anchorLinks: HTMLAnchorElement[] = []

    init(container: Document | Element = document) {
        container.querySelectorAll('a').forEach(element => {
            if ((element as HTMLAnchorElement).matches('[href^="#"]')) {
                this.anchorLinks.push(element as HTMLAnchorElement)
            }

            this.anchorLinks.forEach(link => {
                link.addEventListener('click', this.onAnchorLinkClick)
            })
        })
    }

    onAnchorLinkClick = (e: Event) => {
        e.preventDefault()
        const target = e.target as HTMLElement
        const link = target.closest('a') as HTMLAnchorElement
        if (!link || !link.hash) return

        const targetElement = document.querySelector(link.hash) as HTMLElement
        if (!targetElement) return
        const targetElementTop = targetElement.getBoundingClientRect().top
        const scrollPosition = (appSettings.scroller as HTMLElement).scrollTop - (appSettings.scroller as HTMLElement).getBoundingClientRect().top
        const y = (targetElementTop + scrollPosition)

        const distance = Math.abs(y - (appSettings.scroller as HTMLElement).scrollTop)
        const duration = distance / 2.5 - distance*0.1
        
        document.body.classList.add('scrolling')
        gsap.to(appSettings.scroller, {
            duration: duration / 1000,
            scrollTo: y,
            ease: 'sine.out',
            onComplete: () => { 
                document.body.classList.remove('scrolling')
            }
        })
    }

    update(newContainer: Element) {
        this.anchorLinks = []
        this.init(newContainer)
    }
}

export default new AnchorLinks()

